// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"864":"f4a010c975fbc9d08267","2642":"6aabf80a06cea0fb43e4","3807":"c5880e5158d8cb66bbfb"}[chunkId] + ".js";
};